// frontend/src/components/common/ProductAutocomplete.jsx
import React, { useState, useEffect, useRef } from "react";
import "./Modal.css";
import "../../assets/styles/common.css";

const ProductAutocomplete = ({
  products,
  onSelect,
  selectedIds = [],
  placeholder = "Search for a product...",
  getStockColorClass, // NEW: Added this prop
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const searchContainerRef = useRef(null);

  // Filter products based on search term and exclude already selected items
  useEffect(() => {
    const handler = setTimeout(() => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      if (searchTerm) {
        const filtered = products.filter(
          (product) =>
            !selectedIds.includes(product.id) &&
            (product.brandName.toLowerCase().includes(lowerCaseSearchTerm) ||
              product.genericName.toLowerCase().includes(lowerCaseSearchTerm) ||
              (product.distributor &&
                product.distributor.companyName &&
                product.distributor.companyName
                  .toLowerCase()
                  .includes(lowerCaseSearchTerm)))
        );
        setFilteredProducts(filtered);
      } else {
        const filtered = products.filter(
          (product) => !selectedIds.includes(product.id)
        );
        setFilteredProducts(filtered);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm, products, selectedIds]);

  // Handle click outside to close the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectProduct = (product) => {
    onSelect(product);
    setSearchTerm("");
    setIsDropdownVisible(false);
  };

  return (
    <div className="form-group relative" ref={searchContainerRef}>
      <div className="search-bar" style={{ marginBottom: "10px" }}>
        <span className="search-icon">&#x1F50D;</span>
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsDropdownVisible(true)}
          className="search-input"
        />
      </div>
      {isDropdownVisible && (
        <div className="search-results-dropdown">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="search-result-item"
                onMouseDown={() => handleSelectProduct(product)}
              >
                <strong>{product.brandName}</strong> ({product.genericName})
                {product.manufacturer && ` - ${product.manufacturer}`}
                {product.totalStocks !== undefined && (
                  <span
                    className={
                      "stock-info " + getStockColorClass(product.totalStocks)
                    }
                  >
                    {" "}
                    (Stocks: {product.totalStocks})
                  </span>
                )}
              </div>
            ))
          ) : (
            <div className="no-results">
              {searchTerm
                ? "No products match your search."
                : "Start typing to search for products."}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductAutocomplete;
